<template>
  <div class="patient-paid-stats">
    <div class="patient-paid-stats__left">
      <div class="patient-paid-stats__group">
        <div class="patient-paid-stats__group__title">Оплачено услуг</div>
        <div class="patient-paid-stats__group__value">{{ paid }}</div>
      </div>
      <div class="patient-paid-stats__group">
        <div class="patient-paid-stats__group__title">Не оплачено</div>
        <div class="patient-paid-stats__group__value debt">{{ debt }}</div>
      </div>
      <div class="patient-paid-stats__group">
        <div class="patient-paid-stats__group__title">Аванс</div>
        <div class="patient-paid-stats__group__value">
          {{ advance }}
          <the-tooltip position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="patient-paid-stats__button advance-details-open"
                type="button"
                v-on:click="onAdvanceDetailsOpen"
                v-on="listenerObject"
              >Детализация</button>
            </template>
            операции с авансом
          </the-tooltip>
          <the-tooltip position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="patient-paid-stats__button recharge"
                type="button"
                v-bind:disabled="isAwaitRecharge"
                v-on:click="onClickRecharge"
                v-on="listenerObject"
              />
            </template>
            Пополнить
          </the-tooltip>
          <the-tooltip position="bottom">
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="patient-paid-stats__button withdrawal"
                type="button"
                v-bind:disabled="isAwaitRecharge"
                v-on:click="onClickWithdrawal"
                v-on="listenerObject"
              />
            </template>
            Списать
          </the-tooltip>
        </div>
      </div>
    </div>
    <popover-menu
      v-bind:close-on-content-click="false"
      :top="false"
    >
      <!-- <template v-slot:trigger="{ listenerObject }">
        <button
          class="patient-paid-stats__act"
          type="button"
          v-bind:disabled="isAwaitForceRecharge"
          v-on="listenerObject"
        >
          Акт взаиморасчетов
        </button>
      </template> -->
      <form class="patient-paid-stats__act-form" v-on:submit.prevent="onPrintAct">
        <p>Выберите период</p>
        <div class="patient-paid-stats__act-form__date-range">
          <date-picker-dialog
            v-bind:value="actDateFrom"
            v-on:input="onInputActDateFrom"
          >
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="patient-paid-stats__act-form__date"
                type="button"
                v-on="listenerObject"
                title="От"
              >{{ from }}</button>
            </template>
          </date-picker-dialog>
          <span>—</span>
          <date-picker-dialog
            v-bind:value="actDateTo"
            v-on:input="onInputActDateTo"
          >
            <template v-slot:trigger="{ listenerObject }">
              <button
                class="patient-paid-stats__act-form__date"
                type="button"
                v-on="listenerObject"
                title="До"
              >{{ to }}</button>
            </template>
          </date-picker-dialog>
        </div>
        <button
          class="patient-paid-stats__act-form__button"
          type="submit"
          v-bind:disabled="isPrintActButtonDisabled"
        >
          Печать
        </button>
      </form>
    </popover-menu>
    <button
      v-if="canForceRecharge"
      class="patient-paid-stats__force-recharge"
      type="button"
      v-bind:disabled="isAwaitForceRecharge"
      v-on:click="onForcePayment"
    >
      Провести оплату
    </button>
  </div>
</template>

<script>
import { convertToInputDate, formatDateString } from '@/utils/timeFormat';
import PopoverMenu from '@/components/PopoverMenu.vue';
import TheTooltip from '@/components/TheTooltip.vue';
import DatePickerDialog from './DatePickerDialog.vue';

/**
 * @description Название события открытия формы пополнения.
 * @type {string}
 */
const NAME_EVENT_OPEN_RECHARGE_FORM = 'open-recharge-form';

/**
 * @description Принудительно пополнить аванс.
 * @type {string}
 */
const NAME_EVENT_FORCE_RECHARGE = 'force-recharge';

/**
 * @description Компонент данных оплат пациента.
 */
export default {
  components: {
    PopoverMenu,
    TheTooltip,
    DatePickerDialog,
  },
  computed: {
    from() {
      if (this.actDateFrom) {
        return formatDateString(this.actDateFrom);
      }
      return 'От';
    },
    to() {
      if (this.actDateTo) {
        return formatDateString(this.actDateTo);
      }
      return 'До';
    },
    isPrintActButtonDisabled() {
      return this.actDateFrom === null || this.actDateTo === null;
    },
  },
  data() {
    return {
      actDateFrom: null,
      actDateTo: null,
    };
  },
  methods: {
    /**
     * @description Обработать открытие детализации аванса.
     * @returns {void}
     */
    onAdvanceDetailsOpen() {
      this.$emit('advance-details-open');
    },
    /**
     * @description Обработать нажатие на кнопку пополнения.
     * @returns {void}
     */
    onClickRecharge() {
      this.$emit(NAME_EVENT_OPEN_RECHARGE_FORM);
    },
    /**
     * @description Обработать нажатие снятия с аванса.
     * @returns {void}
     */
    onClickWithdrawal() {
      this.$emit('withdrawal-open');
    },
    onForcePayment() {
      this.$emit(NAME_EVENT_FORCE_RECHARGE);
    },
    onPrintAct() {
      this.$emit('print-act', convertToInputDate(this.actDateFrom), convertToInputDate(this.actDateTo));
    },
    onInputActDateFrom(date) {
      if (this.actDateTo !== null) {
        if (date > this.actDateTo) {
          this.actDateFrom = this.actDateTo;
          this.actDateTo = date;
          return;
        }
      }
      this.actDateFrom = date;
    },
    onInputActDateTo(date) {
      if (this.actDateFrom !== null) {
        if (date < this.actDateFrom) {
          this.actDateTo = this.actDateFrom;
          this.actDateFrom = date;
          return;
        }
      }
      this.actDateTo = date;
    },
  },
  props: {
    /**
     * @description Аванс.
     */
    advance: { required: true, type: String },
    /**
     * @description Разрешить принудительно провести оплату.
     */
    canForceRecharge: { default: false, type: Boolean },
    /**
     * @description Оплачено.
     */
    paid: { required: true, type: String },
    /**
     * @description Долг.
     */
    debt: { required: true, type: String },
    /**
     * @description Ожидание завершения запроса на пополнение.
     */
    isAwaitRecharge: { required: true, type: Boolean },
    /**
     * @description Ожидание выполнения принудительного проведения оплаты.
     */
    isAwaitForceRecharge: { default: false, type: Boolean },
  },
};
</script>

<style scoped lang="scss">
@use "@/scss/buttons";

.patient-paid-stats {
  align-items: center;
  background-color: var(--section-background-color);
  display: flex;
  flex-direction: row;
  gap: 20px 1rem;
  padding: 20px;
  &__left {
    display: flex;
    flex-flow: row wrap;
    gap: 20px 50px;
    width: 100%;
  }
  &__group {
    display: flex;
    flex-direction: column;
    gap: 5px;
    &__title {
      color: #90A0B7;
      font-size: 14px;
      line-height: 17px;
    }
    &__value {
      color: #192A3E;
      display: flex;
      flex-direction: row;
      font-weight: 800;
      font-size: 18px;
      gap: .5rem;
      line-height: 21px;
      &.debt {
        color: var(--warning-color);
      }
    }
  }
  &__act-form {
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    &__date-range {
      display: flex;
      align-items: center;
      gap: 5px;
    }
    &__date {
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex: 1;
      min-width: 150px;
      border-bottom: 1px solid #90A0B7;
      &::after {
        content: '';
        display: inline-block;
        width: 30px;
        height: 30px;
        background-image: url('@/assets/img/calendar.svg');
        background-position: center;
      }
    }
    &__button {
      @include buttons.btn-blue(150px, 32px, 16px);
      align-self: flex-end;
      &:disabled {
        background-color: var(--unfocus-color);
      }
    }
  }
  &__act {
    @include buttons.btn-transparent(100%, 48px, 16px);
    background-color: transparent;
    max-width: 225px;
    padding: 0;
    margin: 0;
    &:before {
      content: "";
      background-image: url("@/assets/img/print.svg");
      background-repeat: no-repeat;
      background-size: contain;
      width: 24px;
      height: 24px;
      margin: 0 8px 0 0;
    }
    &:disabled {
      background-color: var(--unfocus-color);
      &:before {
        background-image: url("@/assets/img/print-white.svg");
      }
    }
  }
  &__force-recharge {
    padding: 0 10px;
    @include buttons.btn-blue(220px, 40px, 14px);
    &:disabled {
      background-color: var(--unfocus-color);
      border: 1px solid var(--unfocus-color);
      color: white;
    }
  }
  &__button {
    border: 1px solid var(--action-color);
    border-radius: 4px;
    font-size: 0;
    height: 1.5rem;
    width: 1.5rem;
    &.recharge {
      background: no-repeat center url("@/assets/img/plus.svg");
    }
    &.withdrawal {
      background: no-repeat center url("@/assets/img/minus-rounded-blue.svg");
    }
    &.advance-details-open {
      background: no-repeat center url("@/assets/img/trending-up.svg");
    }
  }
}
@media screen and (max-width: 700px) {
  .patient-paid-stats {
    flex-direction: column;
    align-items: flex-start;
  }
}
</style>
